import { createRouter, createWebHistory } from 'vue-router'
import PrincpalPage from '../views/PrincipalPage.vue'
import Television from '../views/Television.vue'
import Radio from '@/views/Radio.vue'
import Noticias from '../views/Noticias.vue'
import Donaciones from '../views/Donaciones.vue'
import Modal from '../components/utils/Modal.vue'
import Tienda from '../views/Tienda.vue'
import PreviewNew from '@/views/PreviewNew.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'principalPage',
      component: PrincpalPage
    },
    {
      path: '/television',
      name: 'Television',
      meta: {
        title: 'CCJ Televisión'
      },
      component: Television
    },
    {
      path: '/radio',
      name: 'Radio',
      meta: {
        title: 'CCJ Radio'
      },
      component: Radio
    },
    {
      path: '/noticias',
      name: 'News',
      meta: {
        title: 'CCJ Noticas'
      },
      component: Noticias,
    },
    {
      path: '/donaciones',
      name: 'Donations',
      meta: {
        title: 'CCJ Donaciones'
      },
      component: Donaciones
    },
    {
      path: '/tienda',
      name: 'Store',
      meta: {
        title: 'CCJ Tienda'
      },
      component: Tienda,
      children: [
        {
          path: '/tienda/:id/:detailData/:color',
          name: 'ModalT',
          component: Modal
        },
        {
          path: '/tienda/:detailData',
          name: 'Modal',
          meta: {
            title: 'Carrito de compras'
          },
          component: Modal
        }
      ]
    },
    {
      path: '/noticias/:id/:name',
      name: 'Preview',
      component: PreviewNew
    }
  ]
})

router.beforeEach((to, from) => {
  window.document.title = to.meta && to.meta.title ? to.meta.title : 'Caminando con Jesús Medios';
  if (to.name == 'ModalT') {
    window.document.title = to.params.detailData + ' | Tienda CCJ';
  }
})

export default router
